import { useState, useEffect, useContext } from 'react'
import buildDeliveryEntitiesCollection from '../Dashboarding.functions/buildDeliveryEntitiesCollection.js'
import DatabaseContext from '../../../contexts/Database/DatabaseContext'

const useDeliveryEntitiesPage = () => {
  const { getCollection } = useContext(DatabaseContext)
  const [deliveryEntitiesData, setDeliveryEntitiesData] = useState([])
  const [topProducts, setTopProducts] = useState([])
  const [topBranches, setTopBranches] = useState([])
  const [globalMetrics, setGlobalMetrics] = useState({})
  const [filters, setFilters] = useState({
    entity: 'ALL',
    currency: 'ALL',
    period: 'FY'
  })
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true)
        const dashboardData = await getCollection('dashboardSalesOrders')
        const result = buildDeliveryEntitiesCollection(dashboardData, filters)
        
        setDeliveryEntitiesData(result.deliveryEntities)
        setTopProducts(result.topProducts)
        setTopBranches(result.topBranches)
        setGlobalMetrics(result.globalMetrics)
        setError(null)
      } catch (err) {
        setError(err.message)
      } finally {
        setIsLoading(false)
      }
    }
    
    loadData()
  }, [filters, getCollection])

  const updateFilter = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }))
  }

  return {
    deliveryEntitiesData,
    topProducts,
    topBranches,
    globalMetrics,
    filters,
    updateFilter,
    isLoading,
    error
  }
}

export default useDeliveryEntitiesPage 